
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/[slug]",
      function () {
        return require("private-next-pages/world/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/[slug]"])
      });
    }
  